import { render, staticRenderFns } from "./StudentBusFilter.vue?vue&type=template&id=6bbc7b53&scoped=true&"
import script from "./StudentBusFilter.vue?vue&type=script&lang=js&"
export * from "./StudentBusFilter.vue?vue&type=script&lang=js&"
import style0 from "./StudentBusFilter.vue?vue&type=style&index=0&id=6bbc7b53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbc7b53",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
